import React, { createContext, useContext, useState } from 'react';

const QuotesFilterContext = createContext();
export const useQuotesFilter = () => useContext(QuotesFilterContext);

const getStringDate = (date) => {
    if (!date) return '';
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
        return '';
    } else {
        const year = dateObj.getFullYear().toString();
        const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
        const day = dateObj.getDate().toString();
        return `${year}-${month}-${day}`;
    }
};

const defaultDateRange = 30;
export const QuotesFilterProvider = ({ children }) => {
    const [filters, setFilters] = useState({
        dateRange: defaultDateRange,
        status: [],
        sort: '0',
        numberFilter: '',
        fromFullDate: new Date().setDate(new Date().getDate() - defaultDateRange),
        toFullDate: new Date(),
        fromDate: getStringDate(new Date().setDate(new Date().getDate() - defaultDateRange)),
        toDate: getStringDate(new Date()),
        page: 1
    });

    const updateFilter = (key, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [key]: value,
        }));
    };
    const clearFilters = () => {
        setFilters({
            dateRange: defaultDateRange,
            status: [],
            sort: '0',
            numberFilter: '',
            fromFullDate: new Date().setDate(new Date().getDate() - defaultDateRange),
            toFullDate: new Date(),
            fromDate: getStringDate(new Date().setDate(new Date().getDate() - defaultDateRange)),
            toDate: getStringDate(new Date()),
            page: 1
        });
    };
    return (
        <QuotesFilterContext.Provider value={{ filters, updateFilter, clearFilters }}>
            {children}
        </QuotesFilterContext.Provider>
    );
};